<template>
    <div :class="[
        'flex flex-wrap gap-2.5 py-[18px] h-[88px]',
        { 'bg-gray-F6F6F6': showLabel }
    ]">
        <div
            v-if="showLabel"
            class="flex items-center gap-2.5 font-semibold"
        >
            {{ $t('MY_PALETTE') }}
        </div>
        <button
            type="button"
            class="w-[52px] h-[52px] rounded-full border border-gray-light relative"
            v-for="option in myPalette"
            :key="`${option.value}-${option.slotIndex}`"
            :label="option.label"
            :disabled="disabledValues.includes(option.value)"
            :style="{ backgroundColor: option.color }"
            :class="[
                'focus:outline-none focus:ring-1 focus:ring-black hover:ring-1 hover:ring-black ring-offset-4',
                {
                    'ring-1 ring-black': isSelectedColor(option),
                },
                {
                    'opacity-25': !isAllowed(option),
                },
            ]"
            @click="handleSelectColor(option)"
        >
            <div
                v-if="option.translucent"
                class="absolute inset-0 rounded-full pointer-events-none"
                :style="{ boxShadow: 'inset 0 0 20px rgb(0, 0, 0)' }"
            />
            <div
                v-if="isSelectedColor(option)"
                :class="[
                    'flex items-center justify-center rounded-full absolute pointer-events-none checkbox-visual',
                    'rounded-full w-6 h-6 bg-black bottom-[-8px] right-[-8px] border border-gray-light',
                ]"
            >
                <img
                    src="../assets/images/icons/check-white.svg"
                    width="12"
                    height="12"
                    class="pointer-events-none absolute"
                />
            </div>
        </button>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],
        emits: ['updateColorIsSelected'],
        props: {
            selectedColor: {
                type: String,
                default: null,
            },

            showLabel: {
                type: Boolean,
                default: true,
            },

            limitBy: String,

            disabledValues: {
                type: Array,
                default: () => [],
            },
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            paletteSwatchSlots() {
                return this.customizerStore?.paletteSwatchSlots
                    || ['__empty__-0', '__empty__-1', '__empty__-2', '__empty__-3'];
            },

            myPalette() {
                const masterPalette = this.customizerStore?.masterPalette || [];

                return this.paletteSwatchSlots.map((slotValue, index) => {
                    const match = masterPalette.find((option) => (
                        option.value === slotValue || option.color === slotValue
                    ));

                    if (match) {
                        return {
                            ...match,
                            slotIndex: index,
                        };
                    }

                    return null;
                }).filter(Boolean);
            },

            allowedColors() {
                const allowed = new Set();

                if (this.limitBy) {
                    const placement = this.viewController.findPlacement(this.limitBy);
                    if (placement?.components) {
                        // eslint-disable-next-line no-restricted-syntax
                        for (const c of placement.components) {
                            if (c.placeholder) {
                                // eslint-disable-next-line no-continue
                                continue;
                            }

                            if (c.custom['v-id']) {
                                allowed.add(c.custom['v-id']);
                            }
                        }
                    }
                }

                return allowed;
            },
        },

        methods: {
            isSelectedColor(option) {
                if (!this.selectedColor || !option) {
                    return false;
                }

                const selectedColor = this.selectedColor.toLowerCase();

                return option.color?.toLowerCase() === selectedColor
                    || option.value?.toLowerCase() === selectedColor;
            },

            isAllowed(option) {
                if (this.disabledValues.includes(option.value)) {
                    return false;
                }

                if (this.allowedColors.size > 0) {
                    return this.allowedColors.has(option.id);
                }

                return true;
            },

            handleSelectColor(option) {
                if (!this.isAllowed(option)) {
                    return;
                }

                this.$emit('updateColorIsSelected', option);
            },
        },
    };
</script>
